export const commentKey = 'comment';
export const commentsKey = 'comments';
export const commentByIdKey = 'comment-by-id';
